require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./en-us-update-mdbs-must-not-cook-the-books-on-climate-finance.json") })
        }
      }, "path---en-us-update-mdbs-must-not-cook-the-books-on-climate-finance");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---en-us-update-mdbs-must-not-cook-the-books-on-climate-finance!./.cache/json/en-us-update-mdbs-must-not-cook-the-books-on-climate-finance.json
// module id = 772
// module chunks = 231608221292675